import application from 'application/application';

import templateUrl from './module-movements.template.html';

import controller from './module-movements.controller';

application.config([
	'$stateProvider',
	$stateProvider => {
		$stateProvider.state('root.default.module-movements', {
			url: '/movimentacoes-v2',
			views: {
				'default@root.default': { templateUrl, controller }
			},
			data: {
				documentTitle: 'Movimentações'
			}
		});
	}
]);
